import { useState, useEffect, useRef } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

export default function DateTimePicker({ label, value, onChange }) {
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);

  const [tempDate, setTempDate] = useState(value ? new Date(value) : null);
  const [tempHour, setTempHour] = useState(
    value ? new Date(value).getHours() : 12
  );
  const [tempMinute, setTempMinute] = useState(
    value ? new Date(value).getMinutes() : 0
  );

  const apply = () => {
    if (!tempDate) return;
    const final = new Date(tempDate);
    final.setHours(tempHour);
    final.setMinutes(tempMinute);
    onChange(final);
    setShowPicker(false);
  };

  // 🟡 FERMER EN CLIQUANT À L'EXTÉRIEUR
  useEffect(() => {
    if (!showPicker) return;

    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showPicker]);

  return (
    <div className="w-full relative">
      <label className="font-semibold block mb-1 text-gray-800">{label}</label>

      <button
        onClick={() => setShowPicker(true)}
        className="input input-bordered w-full text-left cursor-pointer"
      >
        {value ? value.toLocaleString() : "Choisir date et heure…"}
      </button>

      {showPicker && (
        <div
          ref={pickerRef}
          className="absolute mt-2 z-50 bg-white shadow-xl border rounded-2xl p-4"
        >
          {/* Calendrier */}
          <DayPicker
            mode="single"
            selected={tempDate}
            onSelect={setTempDate}
            modifiersClassNames={{
              selected:
                "bg-[#FFD76A] text-black font-semibold rounded-full shadow-md",
              today: "border border-[#FFD76A] rounded-full",
            }}
            classNames={{
              nav_button:
                "p-2 rounded-full text-black hover:bg-[#FFD76A] hover:text-black transition",
              nav_button_previous: "mr-1",
              nav_button_next: "ml-1",
            }}
            className="rounded-xl"
          />

          {/* Sélecteurs heures + minutes */}
          <div className="flex gap-3 mt-4">
            <select
              className="select select-bordered w-24"
              value={tempHour}
              onChange={(e) => setTempHour(parseInt(e.target.value))}
            >
              {Array.from({ length: 24 }).map((_, h) => (
                <option key={h} value={h}>
                  {h.toString().padStart(2, "0")}h
                </option>
              ))}
            </select>

            <select
              className="select select-bordered w-24"
              value={tempMinute}
              onChange={(e) => setTempMinute(parseInt(e.target.value))}
            >
              {["00", "15", "30", "45"].map((m) => (
                <option key={m} value={m}>
                  {m}
                </option>
              ))}
            </select>
          </div>

          {/* Boutons */}
          <div className="flex justify-end gap-2 mt-4">
            <button className="btn btn-sm" onClick={() => setShowPicker(false)}>
              Annuler
            </button>

            <button
              className="btn btn-sm text-black"
              style={{ backgroundColor: "#FFD76A", borderColor: "#FFD76A" }}
              onClick={apply}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
